<template>
    <div>
        <div class="login-header fp-login-header">
            <span></span>  <!-- fill button space -->
            <!-- <button
                class="btn-default js-bt-selection-opening"
                @click="toggleOfficeButton()"
            >
                {{view.translations.label_button_office_bb_v5}}
            </button> -->
        </div>
        <div class="paper form login-card">
            <div>
                <img src="/internacional/public/office5/img/general-png/favicon.png">
            </div>
            <h3>{{view.translations.label_lembrar_senha}}</h3>
            <h5>{{view.translations.label_enter_your_registration_email_v5}}</h5>
            <form
                method="post"
                class="form-forgot-password"
                id="form-forgot-password"
                ref="form-forgot-password"
                @submit="forgotPasswordSubmit"
            >
                <div :class="['text-left', input_email == '' ? '' : ($v.input_email.$invalid ? 'has-error' : 'has-success') ]">
                    <label for="email" class="form-label">{{view.translations.label_your_email_v5}}*</label>
                    <input
                        type="email"
                        name="email"
                        class="email"
                        :placeholder="view.translations.label_your_email_v5"
                        required
                        v-model="input_email"
                        @change="onChange('input_email_v', input_email)"
                    >

                    <input type="hidden" name="request_login" value="1">
                </div>
                <div>
                    <button
                        class="btn-success display-block"
                        type="submit"
                        :disabled="$v.input_email.$invalid"
                    >{{view.translations.label_enviar_senha_email}}</button>
                </div>
                 <div class="separator">
                    <hr/><span>
                        {{view.translations.label_or_v5}}
                    </span><hr/>
                </div>
            </form>
            <div class="fp-row-links">
                <div class="dont-have-account">
                    {{view.translations.label_dont_have_an_v5.trim()}}&nbsp;<a :href="view.routes['dont-have-account']" @click="dontHaveAccount" >{{view.translations.label_account_v5}}</a>
                </div>
                <div class="separator"></div>
                <div class="go-back-login">
                    {{view.translations.label_back_to_v5.trim()}}&nbsp;<a :href="view.routes.rota_office_login" @click="goBackToLogin" >{{view.translations.label_login_v5}}</a>
                </div>
            </div>
        </div>
        <div class="login-footer fp-login-footer">
            <div class="all-rights-reserved" >
                {{view.translations.label_all_rights_reserved_v5}}
                <b>
                    {{view.translations.label_ebusiness4us_v5}}
                </b>
            </div>
        </div>
    </div>
</template>

<script>
    const { required, email } = require('vuelidate/lib/validators')
    export default {
        name: 'lv5-fp-form',
        props: ['view'],
        data: function() {
            return {
                input_email: '',
                input_email_v: ''
            }
        },
        validations: {
            input_email: {
                required,
                email
            },
            input_email_v: {
                required,
                email
            }
        },
        methods: {
            forgotPasswordSubmit(){
                this.$emit('forgot-password-submit');
            },
            toggleOfficeButton(){
                this.$emit('toggle-office-button', 'forgot-password')

                var newurl = window.location.protocol + "//" + window.location.host + this.view.routes.rota_office_login_business;
                window.history.pushState({ path: newurl }, '', newurl);

                window.open(newurl,"_self")
            },
            dontHaveAccount(){
                this.$emit('dont-have-account', 'forgot-password')
            },
            goBackToLogin(){
                this.$emit('go-back-to-login', 'forgot-password')
            },
            onChange(key, value) {
                console.log('onchange = ', key, value)
                this[key] = value;
                this.$v[key].$touch();
            }
        },
        mounted(){
            let vm = this;
            $(window).on('load', function(){
                if(vm.view.data.back_toastr_message !== false){
                    vm.$toast[vm.view.data.back_toastr_message_type]( window.getInnerComponent(vm.view.data.back_toastr_message) )
                }
            })
        },
        watch: {
            '$v.$invalid': {
                handler: function(newVal, oldVal) {
                    if(!newVal) {
                        this.$toast.clear();
                    }
                },
                deep: true
            },
            '$v.input_email_v.required': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(`${this.view.translations.label_your_email_v5} ${this.view.translations.label_required_v5}`) );
                    }
                },
                deep: true
            },
            '$v.input_email_v.email': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(this.view.translations.label_invalid_email_v5) );
                    }
                },
                deep: true
            },
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// resources/office/js/components/login-v5/forms/forgotPassword.vue